module.exports = __webpack_public_path__ + "img/ponuky.bd6008c7.svg";